import React from 'react';

import * as S from './styles';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'alert';
}

export function ToastMessage({message, type}: ToastProps): React.JSX.Element {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  return (
    <S.Container type={type} appTheme={appTheme}>
      <S.Text type={type} appTheme={appTheme}>
        {message}
      </S.Text>
    </S.Container>
  );
}

export const toastConfig = {
  success: ({text1}: any) => <ToastMessage message={text1} type="success" />,
  error: ({text1}: any) => <ToastMessage message={text1} type="error" />,
  alert: ({text1}: any) => <ToastMessage message={text1} type="alert" />,
};
